import {
  ManageOwnershipDialog,
  entityToOwnershipEntity,
  useManageOwnershipDialog,
} from '@internal/backstage-plugin-common-library-react';
import React from 'react';

import { useEntity } from '@backstage/plugin-catalog-react';

import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  button: {
    textTransform: 'none',
  },
}));

export const JiraTeamManageOwnership = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const { dialogOpen, openDialog, closeDialog, handleSuccess } =
    useManageOwnershipDialog({ dialogTarget: 'jira-team' });

  return (
    <>
      <Button
        className={classes.button}
        color="primary"
        variant="outlined"
        onClick={openDialog}
      >
        Manage Ownership
      </Button>

      <ManageOwnershipDialog
        open={dialogOpen}
        entities={[entityToOwnershipEntity(entity)]}
        onClose={closeDialog}
        onSuccess={handleSuccess}
      />
    </>
  );
};
